import { render, staticRenderFns } from "./add-type.vue?vue&type=template&id=d666602a&"
import script from "./add-type.vue?vue&type=script&lang=ts&"
export * from "./add-type.vue?vue&type=script&lang=ts&"
import style0 from "./add-type.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports